// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Payroll_UpdateEmployeeAdvanceInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for PUT /payroll/update_employee_advance/{id}
 *
 * Validates input for updating an employee advance (partial update).
 */
import { registerContract } from './validate'

export interface Payroll_UpdateEmployeeAdvanceInput {
title?: string
description?: string
amount?: number
request_date?: string
}

registerContract('Payroll_UpdateEmployeeAdvanceInput', {
  title:        { type: 'string',  required: false },
  description:  { type: 'string',  required: false },
  amount:       { type: 'number',  required: false },
  request_date: { type: 'string',  required: false },
})
